import type {
  FunctionComponentElement,
  ReactComponentElement,
  ReactNode
} from 'react'
import { render, unmountComponentAtNode } from 'react-dom'
import type { Theme } from '@xstyled/styled-components'
import { ThemeProvider as StyledThemeProvider } from '@xstyled/styled-components'
import theme from '../theme'
import { CSSReset, CSSVars } from './globalStyles'

interface ThemeProviderProps {
  theme?: Theme | Record<string, any>
  resetCSS?: boolean
  cssVars?: boolean
  children?: ReactNode
}

export const ThemeProvider = ({
  children,
  resetCSS = true,
  cssVars = false,
  theme: themeProp = theme
}: ThemeProviderProps): JSX.Element => {
  return (
    <StyledThemeProvider theme={themeProp as Theme}>
      {resetCSS && <CSSReset />}
      {cssVars && <CSSVars />}
      {children}
    </StyledThemeProvider>
  )
}

export function renderWithThemeProvider(
  component: FunctionComponentElement<any> | ReactComponentElement<any>,
  container: Element | DocumentFragment,
  options: Omit<ThemeProviderProps, 'children'> = {}
) {
  const { resetCSS = false, ...rest } = options
  render(
    <ThemeProvider resetCSS={resetCSS} {...rest}>
      {component}
    </ThemeProvider>,
    container
  )
  return () => unmountComponentAtNode(container)
}
